module.exports = __webpack_public_path__ + "static/img/031_TO8_1487.f090eeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/031_TO8_1487.jpg
// module id = 6yVp
// module chunks = 0